import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import api from '../utils/api';
import { setAuthData } from '../utils/auth';
import LanguageSwitcher from '../components/LanguageSwitcher';
import Logo from '../components/Logo';

const LoginPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await api.post('/auth/login', formData);
      setAuthData(response.data.token, response.data.user);
      toast.success(t('login') + ' ' + t('qr_created').split(' ').pop());
      navigate('/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || t('error_occurred'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-primary-50 to-white flex items-center justify-center px-6 py-12">
      <div className="absolute top-6 right-6">
        <LanguageSwitcher />
      </div>
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8" data-testid="logo-link">
          <Logo className="h-10 w-10" />
          <span className="text-3xl font-heading font-bold text-primary">cyQRus</span>
        </Link>
        <div className="card p-8 space-y-6" data-testid="login-card">
          <div className="space-y-2 text-center">
            <h1 className="text-2xl font-heading font-bold text-primary">{t('login')}</h1>
            <p className="text-sm text-muted-foreground">{t('hero_subtitle').substring(0, 60)}...</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
            <div className="space-y-2">
              <Label htmlFor="email">{t('email')}</Label>
              <Input
                id="email"
                name="email"
                type="email"
                placeholder="mail@example.com"
                value={formData.email}
                onChange={handleChange}
                required
                data-testid="login-email-input"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">{t('password')}</Label>
              <Input
                id="password"
                name="password"
                type="password"
                placeholder="••••••••"
                value={formData.password}
                onChange={handleChange}
                required
                data-testid="login-password-input"
              />
            </div>
            <Button type="submit" className="w-full btn-primary" disabled={loading} data-testid="login-submit-btn">
              {loading ? t('loading') : t('login_button')}
            </Button>
          </form>
          <div className="text-center text-sm">
            <span className="text-muted-foreground">{t('dont_have_account')} </span>
            <Link to="/register" className="text-accent hover:underline font-medium" data-testid="register-link">
              {t('register')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;